
import Hero from './components/Hero';
import AutoParts from './components/AutoParts';
import ShopInventory from './components/ShopInventory';
import InstallationServices from './components/InstallationServices';
import CustomerReviews from './components/CustomerReviews';
import AboutUs from './components/AboutUs';
import Location from './components/Location';
import Footer from './components/Footer';
import MobileCallButton from './components/MobileCallButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <AutoParts />
      <ShopInventory />
      <InstallationServices />
      <CustomerReviews />
      <AboutUs />
      <Location />
      <Footer />
      <MobileCallButton />
    </div>
  );
}
